import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LoadingButton from '@shared/components/buttons/LoadingButton/LoadingButton';
import type { AddOnsStepFooterProps } from '@components/ProductOffers/configuration/steps/AddOnsStepFooter/AddOnsStepFooter.types';

export const AddOnsStepFooter = ({
  summary,
  onSkip,
  onSubmit,
  confirmLabel,
  onCancel,
  loading,
}: AddOnsStepFooterProps) => {
  return (
    <DialogActions>
      <Typography variant="body.md" className="AddOnsFooter-summary">
        {summary}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1.5} useFlexGap>
        {onCancel ? (
          <Button variant="outlined" onClick={onCancel}>
            <Typography variant="label.button" color="inherit">
              Cancel
            </Typography>
          </Button>
        ) : (
          <Button variant="outlined" onClick={onSkip}>
            <Typography variant="label.button" color="inherit">
              skip add-ons
            </Typography>
          </Button>
        )}
        <LoadingButton variant="contained" onClick={onSubmit} loading={loading}>
          <Typography variant="label.button" color="inherit">
            {confirmLabel ?? 'Add to Plan'}
          </Typography>
        </LoadingButton>
      </Stack>
    </DialogActions>
  );
};
